export const PAGES = {
  home: "/",
  voucher: "/:voucherId",
  quiz: "/quiz/:quizId",
  quizInit: "/quiz/init",
  checkIn: "/check-in/:voucherId",
  unavailableStateForm: "/reach-us",
  oauthTest: "/oauth-test",
  waiver: "/waiver/:voucherId",
  consent: "/update-consent/:voucherId",
};
